const assets = {
  images: {
    logo: require('./images/typescript-logo-240.png'),
    logo1: require('./images/logo1.png'),
    favicon: require('./images/favicon.png'),
  },
}

export default assets
